import { render } from "./BagCheckinModal.vue?vue&type=template&id=3ddf417e&scoped=true"
import script from "./BagCheckinModal.vue?vue&type=script&lang=js"
export * from "./BagCheckinModal.vue?vue&type=script&lang=js"

import "./BagCheckinModal.vue?vue&type=style&index=0&id=3ddf417e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ddf417e"]])

export default __exports__